import './NavMenuOption.css';
import osImage from './money.png';
import osImageBlack from './money-black.png';
import userImage from './group.png';
import userImageBlack from './group-black.png';
import selosImage from './stamp.png';
import selosImageBlack from './stamp-black.png';
import graphImage from './graph.png';
import graphImageBlack from './graph-black.png';
import { INavMenuRoute } from '../../HeaderOptions';
import {INavMenuOption } from '../../../hooks/useHeaderOptions';
import { useIconColor } from '../../../hooks/useIconsColor';



export default function NavMenuOption(props: INavMenuOption)
{
    let image = osImage;
    let iconColor = useIconColor();

    switch(props.Image)
    {
        case 'ITEM': image = iconColor == 'black' ? osImageBlack: osImage;break;
        case 'SELO' : image = iconColor == 'black' ? selosImageBlack: selosImage;break;
        case 'USER' : image = iconColor == 'black' ? userImageBlack: userImage;break;
        case 'GRAPH' : image = iconColor == 'black' ? graphImageBlack: graphImage;break;
        default: image = osImage;
    }
    
    return(
        <div className='NavMenuOption'
            onClick={()=>{ window.location.pathname=`${props.URL}`}}>
                {props.Image}
                <div>
                    <h3>{props.Title}</h3>
                    <p className='MenuOptionSubtitle'>{props.SubTitle}</p>
                </div>                
            </div>
    )
}